import { setData } from "rivals/shared/utils/qa";
import styles from "./index.module.scss";

function FloridaGatorsVideo({
  archiveId
}: {
  archiveId: string;
}): React.JSX.Element {
  return (
    <div className={styles.embedContainer}>
      <iframe
        allowFullScreen
        className={styles.embed}
        src={`https://floridagators.com/showcase/embed.aspx?Archive=${archiveId}&amp;autoplay=false`}
        title={`florida-gators-embed-video-${archiveId}`}
        {...setData(`florida-gators-embed-video`, archiveId)}
      />
    </div>
  );
}

export default FloridaGatorsVideo;
